import React from 'react';
import { Space } from 'antd';
import Layout from './Layout';
import InstallerWorkHub from './InstallerWorkHub';
import InstallerOutboxBadge from './InstallerOutboxBadge';
import InstallerOfflineBanner from './InstallerOfflineBanner';
import '../styles/InstallerWorkHub.css';

/**
 * Новый кабинет монтажника: /installer/work
 * Старый табель остаётся на /installer
 */
const InstallerWorkPage = () => (
    <Layout>
        <div
            style={{
                maxWidth: 560,
                margin: '0 auto',
                padding: '10px 12px 0'
            }}
        >
            <Space
                direction="vertical"
                style={{ width: '100%' }}
                size={8}
            >
                <InstallerOfflineBanner />
                <InstallerOutboxBadge />
            </Space>
        </div>
        <InstallerWorkHub />
    </Layout>
);

export default InstallerWorkPage;
